var $ = require('jquery');

'use strict';

const PricingBox = {
	$picker: [],
	is_setup: false,
	country_code: null,
	init() {
		this.$picker = $('.vc-price-box__select select');
		if ( this.$picker.length > 0 ) {
			this.setup();
		}
	},
	setup() {
		this.$picker.change( this.regionPicked.bind(this) );
		this.is_setup = true;
		if ( this.country_code ) {
			this.pickRegion(this.country_code);
		} else if (
			window.EPIC_GEOLOCATION_DATA
			&& window.EPIC_GEOLOCATION_DATA.country_code
		) {
			this.pickRegion(window.EPIC_GEOLOCATION_DATA.country_code);
		}
	},
	regionPicked() {
		const $option = this.$picker.find(':selected');
		const target = $option.data('target');
		this.updatePricing(target);
	},
	updatePricing(target) {
		$('.vc-price-box__item').removeClass('js-active');
		$('.vc-price-box__item.' + target).addClass('js-active');
	},
	getOptionForCountryCode(country_code) {
		return this.$picker.find('option').filter( (i, el) => {
			let countries = $(el).data('countries');
			if ( typeof countries === 'string' ) {
				countries = countries.split(',');
			} else {
				countries = [];
			}
			return countries.includes(country_code);
		} );
	},
	pickRegion(country_code) {
		if ( !this.is_setup ) {
			this.country_code = country_code;
			return;
		}

		let $option = this.getOptionForCountryCode(country_code);
		if ( $option.length === 0 ) {
			$option = this.getOptionForCountryCode('*');
		}

		this.$picker.val($option.text());
		const target = $option.data('target');
		this.updatePricing(target);
	}
};
window.epic_pricing_box = PricingBox;
$(PricingBox.init.bind(PricingBox));
